import React, { FC } from 'react';

interface YesNoButtonsProps {
  value: string;
  onChange: (value: string) => void;
  options?: readonly string[];
  ariaLabel?: string;
}

const DEFAULT_OPTIONS = ['Yes', 'No'] as const;

const YesNoButtons: FC<YesNoButtonsProps> = ({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  ariaLabel,
}) => (
  <div className="flex gap-2" role="group" aria-label={ariaLabel}>
    {options.map((opt) => {
      const selected = value === opt;
      return (
        <button
          key={opt}
          type="button"
          role="radio"
          aria-checked={selected}
          onClick={() => onChange(opt)}
          className={`flex-1 min-h-yn-btn rounded-md border text-sm transition-all ${
            selected
              ? 'bg-brand border-brand text-white font-semibold'
              : 'bg-white border-slate-200 text-slate-700 font-medium'
          }`}
        >
          {opt}
        </button>
      );
    })}
  </div>
);

export default YesNoButtons;
